/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
import { Color, ColorScale } from '../../mol-util/color';
import { StructureElement, Bond } from '../../mol-model/structure';
import { ParamDefinition as PD } from '../../mol-util/param-definition';
import { AtomPartialCharge } from '../../mol-model-formats/structure/property/partial-charge';
var DefaultPartialChargeColor = Color(0xffff99);
var Description = "Assigns a color based on the partial charge of an atom.";
export var PartialChargeColorThemeParams = {
  domain: PD.Interval([-1, 1]),
  list: PD.ColorList('red-white-blue', {
    presetKind: 'scale'
  })
};
export function getPartialChargeColorThemeParams(ctx) {
  return PartialChargeColorThemeParams; // TODO return copy
}

function getPartialCharge(unit, element) {
  var _a;

  return (_a = AtomPartialCharge.Provider.get(unit.model)) === null || _a === void 0 ? void 0 : _a.data.value(element);
}

export function PartialChargeColorTheme(ctx, props) {
  var scale = ColorScale.create({
    domain: props.domain,
    listOrName: props.list.colors
  });

  function color(location) {
    if (StructureElement.Location.is(location)) {
      var q = getPartialCharge(location.unit, location.element);
      return q !== undefined ? scale.color(q) : DefaultPartialChargeColor;
    } else if (Bond.isLocation(location)) {
      var q = getPartialCharge(location.aUnit, location.aUnit.elements[location.aIndex]);
      return q !== undefined ? scale.color(q) : DefaultPartialChargeColor;
    }

    return DefaultPartialChargeColor;
  }

  return {
    factory: PartialChargeColorTheme,
    granularity: 'group',
    preferSmoothing: true,
    color: color,
    props: props,
    description: Description,
    legend: scale ? scale.legend : undefined
  };
}
export var PartialChargeColorThemeProvider = {
  name: 'partial-charge',
  label: 'Partial Charge',
  category: "Atom Property"
  /* Atom */
  ,
  factory: PartialChargeColorTheme,
  getParams: getPartialChargeColorThemeParams,
  defaultValues: PD.getDefaultValues(PartialChargeColorThemeParams),
  isApplicable: function (ctx) {
    return !!ctx.structure && ctx.structure.models.some(function (m) {
      return AtomPartialCharge.Provider.get(m) !== undefined;
    });
  }
};